import styled from "styled-components";

export const ToolTipLightWeightContainerBox = styled.div<{zIndex: number}>`
  z-index: ${props => props.zIndex};
`;